import styled from "styled-components";
import { useDocumentTitle, scrollBarStyles } from "@dataone/lib";
import { Button, Image } from "antd";
import { withAuth } from "../auth/helpers/hoc";
import { OneGateLogo_3Icon } from "@dataone/icons";

const AccessDeniedPage = () => {
  useDocumentTitle("OneGate | Access Denied");

  return (
    <StyledAccessDeniedPage src="/images/notFound/image1-background.svg">
      <StyledIcon>
        <OneGateLogo_3Icon />
      </StyledIcon>
      <StyledLabel>403 error</StyledLabel>
      <Title>Access Denied</Title>
      <Subtitle>You Do not Have permission to access this page.</Subtitle>
      {/* <StyledButton>Let’s GO Back</StyledButton> */}
    </StyledAccessDeniedPage>
  );
};

export default withAuth(AccessDeniedPage);

const StyledLabel = styled.div`
  color: #fb5050;
  background-color: #ffece9;
  border-radius: 5px;
  width: 100px;
  margin: auto;
  padding: 5px;
  margin-top: 10px;
  margin-bottom: 0 !important;
  text-align: center;
  font-size: 16px;
`;

const StyledButton = styled(Button)`
  background-color: #4974f6 !important;
  height: 41px !important;
  width: 150px !important;
  font-weight: bold !important;
  color: #fff !important;
  border-radius: 8px;
  border: none !important;
`;

const StyledAccessDeniedPage = styled.div<{ src?: string }>`
  background-image: url(${(props) => props.src});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right;
  height: calc(100vh - 90px);
  margin-top: 10px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${scrollBarStyles}
`;

const Title = styled.h1`
  color: #040726;
  font-size: 42px;
  font-weight: 700;
`;

const Subtitle = styled.p`
  font-size: 16px;
  color: #000;
  margin-bottom: 50px;
`;

const StyledIcon = styled.div`
  font-size: 170px;
  display: flex;
  color: #fb5050;
`;
